<template>
  <div>
    <div>
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{ $t('label') }}</th>
          <th>{{ $t('inputType') }}</th>
          <th>{{ $t('equivalentField') }}</th>
          <th v-if="isOutputData">{{ $t('requiredStatuses') }}</th>
          <th></th>
        </tr>
        </thead>
        <tbody v-if="!isOutputData">
        <tr>
          <td>{{$t('name')}}</td>
          <td>{{$t('text')}}</td>
          <td>{{$t('contactName')}}</td>
          <td></td>
        </tr>
        <tr>
          <td>{{$t('phone')}}</td>
          <td>{{$t('text')}}</td>
          <td>{{$t('phone')}}</td>
          <td></td>
        </tr>
        <tr>
          <td>{{$t('desc')}}</td>
          <td>{{$t('text')}}</td>
          <td>{{$t('desc')}}</td>
          <td></td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td>{{$t('result')}}</td>
          <td>{{$t('one')}}</td>
          <td><span class="text-gray-999">{{$t('na')}}</span></td>
          <td><span class="text-gray-999">{{$t('all')}}</span></td>
        </tr>
        <tr>
          <td>{{$t('retryTime')}}</td>
          <td>{{$t('time')}}</td>
          <td><span class="text-gray-999">{{$t('na')}}</span></td>
          <td>{{$t('callback')}}</td>
          <td></td>
        </tr>
        </tbody>
        <tr v-for="item in campaign.contactCustomFields" :key="item.key" class="tr-draggable" :style="item.isOutputData === isOutputData ? '' : 'display: none;'">
          <td>{{ item.label }} <span class="text-gray-999 small">{{item.key}}</span></td>
          <td>{{ $t(item.inputType) }}</td>
          <template>
            <td v-if="item.refKey">{{ getEquivalentField(item.refKey) }}</td>
            <td v-else class="text-gray-999">{{ $t('notUpdated') }}</td>
          </template>
          <td v-if="isOutputData">
            <p v-if="!item.requiredOnStatus.length"><span class="text-gray-999">{{ $t('notRequired') }}</span>
            </p>
            <div v-if="item.requiredOnStatus.length > 0">
              <p v-for="i in item.requiredOnStatus.length" :key="i">
                {{ $t(item.requiredOnStatus[i - 1]) }}
              </p>
            </div>
          </td>
          <td class="text-right">
            <button @click="update(item.key)" v-b-tooltip="$t('detail')"
                    class="btn btn-outline-gray btn-sm is-border-1" type="button">
              <font-awesome-icon icon="info"></font-awesome-icon>
            </button>
          </td>

        </tr>
      </table>
    </div>
    <b-modal v-model="showForm" :title="$t('detail')" no-close-on-backdrop no-enforce-focus>
      <form-input disabled :label="$t('label')" :model="formModel" attribute="label" :errors="formErrors" :placeholder="$t('inputLabel')"></form-input>
      <label>{{$t('key')}} <i class="icon16-help-black mb-1" v-b-tooltip="$t('keyExplain')"></i></label>
      <form-input :disabled="formModel._id" :model="formModel" attribute="key" :errors="formErrors" :placeholder="$t('inputKey')"></form-input>
      <form-select disabled :label="$t('inputType')" :model="formModel" attribute="inputType" :errors="formErrors" :options="inputTypeOptions"></form-select>
      <form-array :disable="true" v-if="formModel.inputType === 'multiple' || formModel.inputType === 'one'" :label="$t('inputOptions')" :model="formModel" attribute="inputOptions" :errors="formErrors"></form-array>
      <label>{{$t('refKey')}} <i class="icon16-help-black mb-1" v-b-tooltip="isOutputData ? $t('refKeyOutputExplain') : $t('refKeyExplain')"></i></label>
      <form-input disabled :model="formModel" attribute="refKey" :errors="formErrors" :options="refOptions"></form-input>
      <form-checkbox-group disabled v-if='formModel.isOutputData' :model="formModel" attribute="requiredOnStatus" errors="formErrors" :label="$t('requiredStatuses')" :options="requiredOnStatusOption"></form-checkbox-group>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import crud from '@/mixins/CRUD';
import list from '@/mixins/List';

export default {
  props: ["isOutputData", "campaign", "title"],
  mixins: [crud, list],
  components: {},
  data: function () {
    return {
      service: '/call-campaign',
      showList: false,
      listTitle: null,
      defaultFormModel: {
        label: '',
        key: '',
        inputType: 'text',
        inputOptions: null,
        isOutputData: this.isOutputData,
        position: 1,
        requiredOnStatus: [],
        refKey: null
      },
      inputTypeOptions: [
        {value: 'text', text: this.$t('text')},
        {value: 'number', text: this.$t('number')},
        {value: 'date', text: this.$t('date')},
        {value: 'one', text: this.$t('one')},
        {value: 'multiple', text: this.$t('multiple')},
      ],
      requiredOnStatusOption: [
        {value: 'ok', text: this.$t('ok')},
        {value: 'deny', text: this.$t('deny')},
        {value: 'callback', text: this.$t('callback')},
        {value: 'failed', text: this.$t('failed')},
      ],
      isEmpty: false,
      refOptions: [
        {value: null, text: this.$t('chooseField')},
        {value: 'customerName', text: this.$t('customerName')},
        {value: 'opportunityName', text: this.$t('opportunityName')},
        {value: 'email', text: this.$t('email')},
        // {value: 'gender', text: this.$t('gender')},
        // {value: 'dob', text: this.$t('dob')},
        {value: 'company', text: this.$t('company')},
        {value: 'title', text: this.$t('title')},
        {value: 'department', text: this.$t('department')},
        {value: 'address', text: this.$t('address')},
        {value: 'website', text: this.$t('website')},
        // {value: 'facebookName', text: this.$t('facebookName')},
        // {value: 'facebookId', text: this.$t('facebookId')},
        // {value: 'zaloName', text: this.$t('zaloName')},
        // {value: 'zaloId', text: this.$t('zaloId')},
      ]
    }
  },
  watch: {
    "formModel.refKey": function (val) {
      if (val) {
        this.formModel.refKey = this.getEquivalentField(val);
      }
    }
  },
  methods: {
    update: function (key) {
      this.formModel = {};
      this.formTitle = this.$t('update');
      this.formErrors = [];
      this.showForm = true;
      this.formModel = this.campaign.contactCustomFields.find(item => {
        return item.key === key;
      });
      this.formModel.id = key;
    },
    getEquivalentField(key) {
      let label = this.refOptions.find(f => f.value === key);
      if (label) {
        return label.text;
      } else {
        return key;
      }
    }
  },
  mounted() {
    this.refOptions = this.refOptions.concat(
        this.campaign.contactCustomFields.map(item => {
          return {value: item.key, text: item.key}
        })
    );
  },
  i18n: {
    messages: {
      vi: {
        label: "Tên trường dữ liệu",
        inputType: "Kiểu nhập liệu",
        equivalentField: "Trường thông tin tương ứng",
        contactName: "Tên liên hệ",
        result: "Kết quả",
        retryTime: "Thời gian hẹn gọi lại",
        number: "Nhập số",
        one: "Chọn một",
        text: "Nhập chữ",
        customerName: "Tên khách hàng",
        opportunityName: "Tên cơ hội bán hàng",
        email: "Email",
        company: "Công ty",
        title: "Chức danh",
        department: "Phòng ban",
        website: "Website",
        na: "Không có",
        requiredStatuses: "Bắt buộc nhập nếu cuộc gọi có kết quả là",
        ok: "Đồng ý",
        deny: "Từ chối",
        callback: "Hẹn gọi lại",
        failed: "Thất bại",
        notRequired: "Không bắt buộc nhập",
        key: "Mã",
        inputOptions: "Danh sách lựa chọn",
        date: "Thời gian",
        multiple: "Chọn nhiều",
        refKey: "Trường thông tin tương ứng của khách hàng",
        chooseField: "Chọn trường",
        address: "Địa chỉ",
        close: "Đóng" ,
      },
      en: {
        label: "Tên trường dữ liệu",
        inputType: "Kiểu nhập liệu",
        equivalentField: "Trường thông tin tương ứng",
        contactName: "Tên liên hệ",
        result: "Kết quả",
        retryTime: "Thời gian hẹn gọi lại",
        number: "Nhập số",
        one: "Chọn một",
        text: "Nhập chữ",
        customerName: "Tên khách hàng",
        opportunityName: "Tên cơ hội bán hàng",
        email: "Email",
        company: "Công ty",
        title: "Chức danh",
        department: "Phòng ban",
        website: "Website",
        na: "Không có",
        requiredStatuses: "Bắt buộc nhập nếu cuộc gọi có kết quả là",
        ok: "Đồng ý",
        deny: "Từ chối",
        callback: "Hẹn gọi lại",
        failed: "Thất bại",
        notRequired: "Không bắt buộc nhập",
        key: "Mã",
        inputOptions: "Danh sách lựa chọn",
        date: "Thời gian",
        multiple: "Chọn nhiều",
        refKey: "Trường thông tin tương ứng của khách hàng",
        chooseField: "Chọn trường",
        address: "Địa chỉ",
        close: "Đóng" ,
      }
    }
  }
};
</script>
<style>
.text-gray-999 {
  color: #999;
}
</style>
